/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { UsersAuthzCheckUserPermissionUserPermissionsQueryResponse, UsersAuthzCheckUserPermissionUserPermissionsPathParams, UsersAuthzCheckUserPermissionUserPermissions401, UsersAuthzCheckUserPermissionUserPermissions403 } from "../models/UsersAuthzCheckUserPermissionUserPermissions";

export function getUsersAuthzCheckUserPermissionUserPermissionsUrl(permission: UsersAuthzCheckUserPermissionUserPermissionsPathParams["permission"]) {
  const res = { method: 'GET', url: `/users-authz/v1/user/permissions/${permission}` as const }
  return res
}

/**
 * @summary Check if the current user has a specific permission
 * {@link /users-authz/v1/user/permissions/:permission}
 */
export async function usersAuthzCheckUserPermissionUserPermissions(permission: UsersAuthzCheckUserPermissionUserPermissionsPathParams["permission"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<UsersAuthzCheckUserPermissionUserPermissionsQueryResponse, ResponseErrorConfig<UsersAuthzCheckUserPermissionUserPermissions401 | UsersAuthzCheckUserPermissionUserPermissions403>, unknown>({ method : "GET", url : getUsersAuthzCheckUserPermissionUserPermissionsUrl(permission).url.toString(), ... requestConfig })
  return res.data
}